<template>
	<v-card>
		<v-card-text class="pa-0">
			<!-- <v-divider></v-divider> -->
			<v-data-table
			    dense
			    hide-default-footer
			    fixed-header
			    show-select
			    v-model="infoToFilter.faceListSelecteds"
			    :headers="headers"
			    :items="renderList"
			    :items-per-page="50"
			    class="elevation-1"
			    height="200"
			    item-key="name"
			    :loading="loading"
			    @input="renderSelections()"
			>
				<template v-slot:header.name="{ header }">
			      {{ $ml.get(header.text).toUpperCase() }}
			    </template>
			    <template v-slot:header.data="{ header }">
			      {{ $ml.get(header.text) }}
			    </template>
			    <template v-slot:item.data="{item, index}">
			    	
        			<v-tooltip bottom>
         				<template v-slot:activator="{ attrs , on }">
		    				<v-btn dark small v-bind="attrs" v-on="on" @click="openDialog(item)">
		    					<v-badge							        
							    	left    	
							    	bottom
							        overlap
							        bordered
							        :color="item.data && item.data.length > 1 ? 'green' : 'secondary'"
							        :content="renderCountSelecteds(item)"
							        offset-x="5"
							        offset-y="18"					
							    >						        
		    						<v-icon>mdi-face</v-icon>
								</v-badge>
		    				</v-btn>
		    			</template>
          				<span>{{$ml.get("faces") }}</span>
          			</v-tooltip>
		          		
			    </template>
			</v-data-table>
			
			<v-divider></v-divider>
		</v-card-text>
		<v-card-actions class="text-h5">
			<strong class=" mt-2">			
				# {{  renderList.length }}
			</strong>
			<v-dialog transition="dialog-bottom-transition" v-model="dialog" :width="800">  
				<v-card outlined>
					<v-card-title class="blue darken-3 header-1 pa-0">
						<v-spacer></v-spacer>
						<strong> {{$ml.get('faces')}}</strong>
						<v-spacer></v-spacer>
						<v-btn fab x-small color="error"  @click="dialog=false"><v-icon>mdi-close</v-icon></v-btn>
					</v-card-title>
                    <v-card-text class="pa-1">                        
					   <ItemsGroupFaces :infoToComponent="infoItem" :infoToFilter="infoToFilter" @recivedEditItem="isEditingItem=$event"></ItemsGroupFaces>
                    </v-card-text>
                    <v-spacer/>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>                        
                        <v-btn small color="success" @click="renderSelection()">{{$ml.get('confirm')}}</v-btn>
                        <v-spacer></v-spacer>                        
                    </v-card-actions>
				</v-card>
			</v-dialog>
			
		</v-card-actions>
	</v-card>
</template>
<script type="text/javascript">
 	import ItemsGroupFaces from "@/components/face/ItemsGroupFaces.vue"
	export default{
		name: "SidebarFaces",
		components:{ItemsGroupFaces},
		props:["infoToFilter"],
		data: ()=>({
			loading:false,
			messageErrorUpload: [],
			isEditingItem : false,
			headers : [
				{ text : "faces", value: "data"},
				{ text : "list", value: "name", width:200},
			],
			list : [],
			infoItem : null,
			dialog: false,
		}),
		mounted(){
			this.getList();
		},
		computed:{
			renderList(){
				return this.list;
			},			
		},
		methods:{
			triggerFileInput(){				
				this.$refs.uploadImage.$el.querySelector('input[type="file"]').click();
			},
			deleteItem(item){
				this.infoItem=item;
				const idx = this.renderList.indexOf(item);				
			},
			openDialog(item){
				this.infoItem=item;
				this.dialog=true;
			},
			renderSelections(){
				// console.log("CHECK  SELECtion ", this.infoToFilter.faceListSelecteds, this.infoToFilter.selectedsListUUID, this.isEditingItem )
				if(!this.isEditingItem){
					this.infoToFilter.faceListSelecteds.forEach(z=> {
						if(z.selections.length===0){
                            z.selections=z.data.map((it)=> it.uuid)
                        }
                    })
					this.renderList.forEach(x=>{
                        if(!this.infoToFilter.faceListSelecteds.includes(x)){
                            x.selections=[];
                        }
                    });		
				}

			},

			renderCountSelecteds(item){
				if(item?.data && item.data.length){						
				// console.log("CHECK SELecteds ",item)				 
					return `${item.selections.length}/${item.data.length}` 
				}
				return '0/0'
			},
            renderSelection(){
                // this.$emit("recivedEditItem",true);             
                // console.log("reval", this.infoItem)          
                if(this.infoItem){                   
                    if(this.infoItem.selections.length===0 ){ 
                        const idx=this.infoToFilter.faceListSelecteds.findIndex(x=>this.infoItem.name==x.name)
                        if(idx>=0){
                            this.infoToFilter.faceListSelecteds.splice(idx,1);
                        }                       
                    }else {
                        const idx=this.infoToFilter.faceListSelecteds.findIndex(x=>this.infoItem.name==x.name)
                        if(idx==-1){
                            this.infoToFilter.faceListSelecteds.push(this.infoItem);
                        }
                        // this.infoToFilter.
                        
                    }                
                    this.dialog=false;
                }
                // this.$emit("recivedEditItem",false);                
            },
			async getList(){
				try{
					this.loading=true;
					const uri=this.$URL+"/api/v1/listing_details_type2/face/"                    
					await this.$axios.get(uri).then(res=>{
						if(res && res.data && res.data.length){
							this.list=res.data.map(x=> {
								x.selections=[];
								return x
							});
						}
					
                    }).catch(error => {
						throw error
						// console.warn("get list faces for search by video ", error)
					});


				}catch(error){
					console.warn("get list faces for search by video ", error)
				}finally{
					this.loading=false;
				}
			}
		}, // methods
	}
</script>